module.exports = __webpack_public_path__ + "img/clothes-002.408a7d4a.jpg";